<!-- eslint-disable -->
<template>
  <div style="margin-top: 10px">
    <div style="background-color: #ffffff; height: 80px">
      <div class="header-group">
        <div class="header-logo">
          <a href="/">
            <img
              src="/img/logo_arvalis.png"
              alt="Logo"
              class="logo-arvalis-header"
              min-width="188"
              width="270"
            />
          </a>   
        </div>
        <div class="header-logo" max-width="300">
          <div class="nom-outil">Choix des buses et réglage du pulvérisateur</div>
        </div>
      </div>
    </div>




    <!-- NAVIGATION BAR BELOW THE LOGO -->
    <div color="primary" dark style="height: 25px;background-color: #087b7a; color: white;" class="d-flex d-none d-md-flex align-center">
      <!-- Desktop Menu (Hidden on Mobile) -->
      <v-spacer></v-spacer>
      <div class="d-none d-md-flex">
        <router-link to="/" class="link">Accueil</router-link> |
        <router-link to="/pulverisation/plein" class="link">Pulvérisation en plein</router-link> |
        <router-link to="/pulverisation/localisee" class="link">Pulvérisation localisée</router-link> |
        <router-link to="/about" class="link">En savoir plus</router-link> |
        <a
          href="https://www.arvalis.fr/outils-et-services/outils-et-fiches"
          class="link"
          target="_blank"
          >Plus d'outils</a
        >
      </div>

      <!-- Mobile Menu Button -->
      <div icon class="d-md-none" style="margin-right: 10px;" @click="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </div>
    </div>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" temporary app>
      <v-list>
        <v-list-item>
          <v-list-item-title><router-link class="link-mobile" to="/">Accueil</router-link></v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title><router-link class="link-mobile" to="/pulverisation/plein">Pulvérisation en plein</router-link></v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title><router-link class="link-mobile" to="/pulverisation/localisee">Pulvérisation localisée</router-link></v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title><router-link class="link-mobile" to="/about">En savoir plus</router-link></v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.arvalis.fr/outils-et-services/outils-et-fiches">
          <v-list-item-title>Plus d'outil</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>


  </div>
</template>
<script>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default {
  setup() {},
  name: "App",
  data() {
    return {
      drawer: false,
    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="css">
.v-responsive.v-img {
  max-width: 13%;
}
.profil-menu {
  background-color: white;
}
.colorText {
  color: white !important;
  font-size: 0.7rem;
}
a {
  text-decoration: none;
}
.active-profil {
  //border: 1px solid green;
  background-color: lightgreen;
  font-weight: bolder !important;
}
.logo-container {
  display: flex;
  justify-content: flex-start;
  padding: 20px;
  align-items: center;
}

.logo {
  height: 60px;
  cursor: pointer;
}
.tool-name {
  margin-left: 20px;
  font-size: 1.6em;
  color: #087b7a;
}
.nav-bar {
  background-color: #087b7a;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.links {
  display: flex;
  align-items: center;
  gap: 20px;
  color: white;
}

.link {
  color: white;
  text-decoration: none;
  margin: 0px 15px 0px 15px;
}
.link-mobile {
  color: #087b7a;
  text-decoration: none;
}
.header-group {
  width: 70%;
  margin: auto;
}

.logo-arvalis-header {
  position: relative;
  float: left;
  margin-right: 15px;
  top: 10px;
  z-index: 999;
}

.nom-outil {
  color: #087b7a;
  text-shadow: none;
  position: relative;
  top: 33px;
  z-index: 999;
  float: left;
  font-size: 1.8em;
  font-weight: bold;
}

.bandeau {
  background-color: #087b7a;
  height: 22px;
}

.header {
  border-bottom: 0;
  height: 80px;
  background-color: #ffffff;
  margin-bottom: 30px;
}

.v-list-item-title {
  color: #087b7a;
}

@media screen and (max-width: 650px) {
  .header {
    height: 120px;
  }
  .header-group {
    overflow: hidden;
    text-align: center;
  }
  .header-logo {
    width: 100%;
    overflow: hidden;
  }
  .header {
    background-color: #ffffff;
  }
  .logo-arvalis-header {
    clear: both;
    float: none;
    margin-right: 0px;
    top: 0px;
    z-index: 999;
    width: 120px;
  }
  .container_autre {
    width: 85%;
  }
  .nom-outil {
    position: static;
    float: none;
    color: #087b7a;
    text-shadow: none;
    top: 33px;
    z-index: 999;
    font-size: 1.1em;
    font-weight: bold;
  }
}
</style>
